import { create } from 'zustand';
import { SearchState } from '../components/Search/SearchState';

export const useSearchStore = create<{
  search: null | SearchState;
  setSearch: (search: SearchState) => void;
}>((set) => ({
  search: null,
  setSearch: (search: SearchState) => set(() => ({ search })),
}));
